import { createStore, combineReducers } from 'redux'
import deviceReducer from './user_device/reducer'
import pageNameReducer from './page_name/reducer'
import childPageNameReducer from './child_page_name/reducer'
import mobileReducer from './user_mobile/reducer'

let rootReducer = combineReducers({
  deviceReducer,
  pageNameReducer,
  childPageNameReducer,
  mobileReducer,
})

export const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)

export default store
